import React, { Component } from 'react';
import { Collapse } from 'antd';
import './layout.css';
const Panel = Collapse.Panel;

class FAQ extends Component {

  render() {
    return (
        <div className='widget FAQ'>
        <div className='widget-container'>
        <div className="widget-header">
        <div className='title'>
            Frequently Asked Questions
        </div>
        <div className = 'setting'>
             <a><i className="fa fa-image margin-right-5"></i> Take Tour </a>
        </div>
        </div>
            <Collapse bordered={false} accordion defaultActiveKey={['1']}>
                <Panel header="How do I create a list?" key="1">
                <p>Click the “Advanced Search” in the menu bar or click the “Create a List” button. Limit list results by adding and adjusting filters. You can group filter conditions together to determine which filter conditions are executed first (your order of operations). The filter that you are creating and order of operations is listed below under the title “List Formula.” Click the “Show List Results” button when you have completed determining your filters.  This will display your list results. You can export your list to your computer by clicking “Export as” or print your list by clicking “Print”  </p>
                <p> You may also change the information displayed by clicking “Change Columns” </p>
                <p>If you want to reference your filter conditions in the future, you may save them in “My List Folder (only)”, where they are only viewable to you. Note: data in the alumni directory is changing in real time, you may find that your list conditions will produce a different list when run again later. Common filters have been saved in the Public Folder and are available to you. However, list results are limited to your council only. </p>
                </Panel>
                <Panel header="Can I make my Eagle list include Eagles who earned their Eagle in my council and include Eagles that have moved into my council from another council?" key="2">
                <p>Yes, when Eagle Scouts move from one council to another and their address is updated in the directory, their record is made available to their new council. The filters for this list have already been established in the Public Lists folder under “Eagles earned inside or outside council”</p>
                </Panel>
                <Panel header="Can I limit my Eagle list to only Eagles that earned their Eagle in my council? " key="3">
                <p>Yes, the filters for this list have already been established in the Public Lists Folder under “Eagles earned inside council only”</p>
                </Panel>
                <Panel header="Can I make my Eagle list include all Eagles who have had an association with my council?" key="4">
                <p>Yes, the filters for this list have already been established in the Public Lists Folder under “All Eagles associated with my council”</p>
                </Panel>
                <Panel header="Why can’t I delete a constituent?" key="5">
                <p>Text here</p>
                </Panel>
                <Panel header="Can constituent records be merged?" key="6">
                <p>Text here</p>
                </Panel>
            </Collapse>
        </div>
        </div>
    );
  }

}

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/Inc/FAQ.js